export default Object.freeze({
  IT_MELBOURNE: 8,
})
